








export default {
  name: 'App',
  computed: {
    companyName() {
      return this.$store.state.user.companyName || '默认标题';
    }
  },
  watch: {
    companyName(newVal) {
      // 监听 companyName 的变化，自动更新 document.title
      document.title = newVal;
    }
  },
  created() {
    // 初始化时设置标题
    document.title = this.companyName;
  }
}
